const initialState = {
  groupOrganizations: [],
  groupOrganizationDetail: {},
  userDataList: [],
  windowScrollX: 0,
  windowScrollY: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ORGANIZATIONS_GET_ORGANIZATION":
      return {
        ...state,
        params: action.params,
        groupOrganizations: action.data.groupOrganizations,
      };
    case "ORGANIZATIONS_GET_ORGANIZATION_DETAIL":
      return {
        ...state,
        groupOrganizationDetail: action.data.groupOrganization,
      };
    case "ORGANIZATIONS_GET_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "ORGANIZATIONS_DELETE_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "ORGANIZATIONS_ADD_EXPERTISE":
      return {
        ...state,
        expertise: action.data.expertise,
      };
    case "ORGANIZATIONS_GET_MEMBER":
      return {
        ...state,
        userDataList: action.data.userDataList,
      };
    case "ORGANIZATION_SET_WINDOW_SCROLL":
      return {
        ...state,
        windowScrollX: action.windowScrollX,
        windowScrollY: action.windowScrollY,
      };
    default:
      return state;
  }
};

export default reducer;
